module.exports = __webpack_public_path__ + "static/img/faq_service01.bfce29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service01.png
// module id = 9EdE
// module chunks = 2